// extracted by mini-css-extract-plugin
module.exports = {"btn":"LinkButton_btn__3li09"};